$(document).ready(function () {

    $(".main_banner_slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: false,
        infinite: true,
        fade: true,
    });

  $(".products-grid").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        arrows: false,
        infinite: true,
        fade: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2.5,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2.3,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1.03,
            }
          }
        ]
    });


});


document.querySelectorAll('.dropdown_has_menu').forEach((e) => {
    e.addEventListener('click', (event) => {
        event.stopPropagation();
        e.classList.toggle('open');
        document.querySelectorAll('.dropdown_has_menu').forEach((other) => {
            if (other !== e) {
                other.classList.remove('open');
            }
        });
    });
});

// Show loader on page load
window.addEventListener('load', function () {
    const loaderElement = document.querySelector('.main_loader');
    if (loaderElement) {
        loaderElement.classList.add('load');
    }
});

const mainNavIcon = document.querySelector('.main_menu_icon');
const mainNAvMenu = document.querySelector('.nav_menu_main');
const mainNavClose = document.querySelector('.open_menu_bg_nav');

mainNavIcon.addEventListener('click', () => {
    mainNAvMenu.classList.toggle('active')
});

mainNavClose.addEventListener('click', () => {
    mainNAvMenu.classList.remove('active')
})

const sections = ['.main_banner', '.fassion_section_main', '.new_arrivals_main', '.sale_main_section', '.wedding_collection_main', '.wedding_collection_main_products', '.women_style_main', '.latest_collection_main_products', '.online_store_main', '.proudly_made_main', '.main_footer', '.wearzed_main', '.online_store_main_men', '.proudly_made_main_men'];
const sectionsMen = ['.main_banner', '.fassion_section_main', '.new_arrivals_main', '.sale_main_section', '.wedding_collection_main', '.wedding_collection_main_products', '.women_style_main', '.latest_collection_main_products', '.online_store_main', '.proudly_made_main', '.main_footer', '.wearzed_main', '.latest_obsessions_men_index', '.main_footer', '.deskto_impress_men', '.wedding_collection_main_men', '.latest_obsessions_men_index'];

const observeSections = (sections, headerSelector, suffix) => {
    const headerElement = document.querySelector(headerSelector);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.target && entry.target.className) {
                const sectionClass = entry.target.className.split(' ')[0];

                if (entry.isIntersecting) {
                    sections.forEach((sec) => {
                        headerElement.classList.remove(sec.replace('.', '') + suffix);
                    });
                    entry.target.classList.add('close-to-header');
                    entry.target.classList.remove('not-close-to-header');
                    headerElement.classList.add(sectionClass + suffix);
                } else {
                    entry.target.classList.remove('close-to-header');
                    entry.target.classList.add('not-close-to-header');
                    headerElement.classList.remove(sectionClass + suffix);
                }
            }
        });
    }, { root: null, threshold: [0.5, 1] });

    sections.forEach((section) => {
        const sectionElement = document.querySelector(section);
        if (sectionElement) {
            observer.observe(sectionElement);
        } else {
           // console.warn(`Section ${section} not found on this page.`);
        }
    });
};

if (document.querySelector('.main_header')) {
    observeSections(sections, '.main_header', '-close');
} else {
   // console.warn('Header .main_header not found on this page.');
}

if (document.querySelector('#menHeader')) {
    observeSections(sectionsMen, '#menHeader', '-men');
} else {
    // console.warn('Header #menHeader not found on this page.');
}


// gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// let sectionSelectors = document.querySelectorAll('.for_sticky_part');

// function goToSection(section) {
//     gsap.to(window, {
//         scrollTo: { y: section, autoKill: false, ease: "Power3.easeInOut" },
//         duration: 0.1
//     });
// }

// ScrollTrigger.defaults({
//     // markers: true
// });

// sectionSelectors.forEach((panel) => {
//     let sectionOffset = panel.offsetTop;

//     if (panel) {
//         ScrollTrigger.create({
//             trigger: panel,
//             start: "top 90%",  // Triggers when 10% of the viewport enters the section
//             onEnter: (self) => {
//                 goToSection(sectionOffset);
//             }
//         });

//         ScrollTrigger.create({
//             trigger: panel,
//             start: "bottom 10%",  // Triggers when scrolling back up past 10% of the section
//             onEnterBack: (self) => {
//                 goToSection(sectionOffset);
//             }
//         });
//     }
// });

// Select all sections with the class 'for_sticky_part'
let sectionSelectors = document.querySelectorAll('.for_sticky_part');

// Function to scroll smoothly to a section
function goToSection(section) {
    window.scrollTo({
        top: section.offsetTop,  // Scroll to the top offset of the section
        behavior: 'smooth'       // Enable smooth scrolling
    });
}

// Debounce function to limit scroll triggers
function debounce(func, delay) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

// Create an IntersectionObserver to monitor when sections come into view
let observer = new IntersectionObserver(debounce((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            // When 30% of the section is in view, scroll to that section
            goToSection(entry.target);
        }
    });
}, 200), {  // Delay set to 200ms to allow smoother scrolling
    root: null,  // The viewport
    threshold: 0.3 // Trigger when 30% of the section is visible
});

// Observe each section
sectionSelectors.forEach((panel) => {
    observer.observe(panel);
});



function reveal() {
    var reveals = document.querySelectorAll(".reveal");

    reveals.forEach(function (reveal) {
        var windowHeight = window.innerHeight;
        var elementTop = reveal.getBoundingClientRect().top;
        var elementVisible = 100;

        if (elementTop < windowHeight - elementVisible) {
            reveal.classList.add("active");
        } else {
            reveal.classList.remove("active");
        }
    });
}

window.addEventListener("scroll", reveal);

function revealOpacity() {
    var reveals = document.querySelectorAll(".reveal_opacity");

    reveals.forEach(function (reveal) {
        var windowHeight = window.innerHeight;
        var elementTop = reveal.getBoundingClientRect().top;
        var elementVisible = 100;

        if (elementTop < windowHeight - elementVisible) {
            reveal.classList.add("active");
        } else {
            reveal.classList.remove("active");
        }
    });
}

window.addEventListener("scroll", revealOpacity);

